import { useCallback, useEffect } from 'react';

import debounce from 'lodash/debounce';

import { StyledButton } from './ButtonV2.styles';

export const ButtonV2 = ({
  onClick,
  debounceDelay = 0,
  disableElevation = true,
  children,
  ...props
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedClick = useCallback(
    debounce((e) => onClick?.(e), debounceDelay, {
      leading: true,
      trailing: false,
    }),
    [onClick, debounceDelay],
  );

  useEffect(() => () => debouncedClick.cancel(), [debouncedClick]);

  return (
    <StyledButton disableElevation={disableElevation} {...props} onClick={debouncedClick}>
      {children}
    </StyledButton>
  );
};
